// TEAM: tambahkan ulasan ASLI di sini. Jangan pernah menambahkan ulasan fiktif.
// Format: { name: "Nama/Inisial", text: { id: "...", en: "..." }, rating: 5, source: "Google" }
export const TESTIMONIALS = [];

// Isi setelah terverifikasi, contoh: { value: "4.9", count: 27 }
export const GOOGLE_RATING = null;
